import "moment-timezone";
import { nameOf } from "../utils/object.js";
import "react-intl";
class UserSettings {
  id;
  userId;
  featureName;
  settingName;
  value;
}
const dbUserSettingsIndex = `[${[nameOf("userId"), nameOf("featureName"), nameOf("settingName")].join("+")}]`;
const dbUserSettingsStorageConfig = { userSettings: `++${nameOf("id")}, ${dbUserSettingsIndex}` };
export {
  UserSettings,
  dbUserSettingsStorageConfig
};
//# sourceMappingURL=types.js.map
